<template>
  <div class="py-2">
    <div class="flex justify-start">

      <div class="w-full">
          <div class="relative">
              <select name="emr_id" id="emrs" class="input float-input peer " v-model="emr" placeholder="EMR">
                <!-- <option value="" selected disabled hidden></option> -->
                <option v-for="emr in list" :key="emr.id" :value="emr.id">{{ emr.name }}</option>
                <option value="other">Other</option>
              </select>
              <label
                for="emrs"
                class="float-label"
                :class="{
                    'font-normal': emr == '',
                }"
            >EMR Name</label>
              <!-- This mostyl works, except not as responsive when clicked, should be quick fix, but worry about that later -->
                  <!-- <label
                for="emrs"
                class="absolute left-2 focus-float-label"
                :class="{
                    'font-normal': emr == '',
                    'top-3': emr == '',
                    'text-logo': emr == '',
                    'text-base': emr == '',
                    'top-0' : emr != '',
                    'text-logo-light' : emr != '',
                    'font-light' : emr != '',
                    'text-sm' : emr != '',
                    'transition-transform' : emr != '',
                }"
            >EMR Name</label> -->
          </div>
        <!-- </div> -->
        <div class="pt-4" v-if="emr == 'other'">
            <div class="relative">
                <input id="other" type="text" class="input float-input peer" v-model="other" placeholder="other">
                <label for="other" class="float-label">Name of your emr</label>
            </div>
            <button class="btn btn-logo mt-4" type="button" @click="add">Add to List</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["emrs", "multiple", 'selected'],
  data() {
    return {
      list: this.emrs,
      emr: this.selected,

      other: ''
    //   back: this.levels * 1 || 1,
    //   normal: this.history ? true : false
    };
  },
  mounted() {

  },
  methods: {
    add() {
        if (this.other == '' || this.other == null)
            return alert('Please provide the name of your EMR or select one from the dropdown')
      axios.post('/emrs', {'name': this.other})
        .then(({data}) => {
          // console.log(this.list.some(elem => elem.id === data.id));
          if (this.list.some(elem => elem.id === data.id) == false) {
            this.list.unshift(data);
          }
          this.emr = data.id;
        })
    }
    // goBack() {
    //   if (this.normal) {
    //     window.history.back();
    //   } else {
    //     var t = window.location.href;
    //     t = t.substr(0, t.nthLastIndexOf("/", this.back));
    //     window.location.href = t;
    //   }
    // }
  }
};
</script>
